var _path, _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "url(#paint0_radial_752_6435)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_752_6435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8843 6H15.1157C10.0813 6 6 10.0812 6 15.1157V32.8843C6 37.9188 10.0813 42 15.1157 42H32.8843C37.9188 42 42 37.9188 42 32.8843V15.1157C42 10.0812 37.9188 6 32.8843 6Z",
    fill: "url(#paint1_linear_752_6435)",
    fillOpacity: 0.4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_752_6435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.344 29.0275C31.0718 29.6563 30.7495 30.2352 30.3762 30.7674C29.8674 31.4929 29.4507 31.9952 29.1296 32.274C28.6318 32.7318 28.0985 32.9662 27.5274 32.9796C27.1174 32.9796 26.623 32.8629 26.0475 32.6263C25.47 32.3907 24.9394 32.274 24.4542 32.274C23.9453 32.274 23.3996 32.3907 22.8158 32.6263C22.2311 32.8629 21.7602 32.9862 21.4001 32.9985C20.8524 33.0218 20.3065 32.7807 19.7617 32.274C19.4139 31.9707 18.9789 31.4507 18.4578 30.7141C17.8987 29.9274 17.4391 29.0152 17.079 27.9753C16.6933 26.852 16.5 25.7642 16.5 24.7112C16.5 23.5049 16.7607 22.4644 17.2828 21.5926C17.6931 20.8923 18.2389 20.3398 18.9221 19.9343C19.6053 19.5288 20.3435 19.3221 21.1385 19.3089C21.5735 19.3089 22.1439 19.4434 22.8528 19.7079C23.5597 19.9732 24.0135 20.1077 24.2125 20.1077C24.3613 20.1077 24.8655 19.9504 25.7203 19.6368C26.5286 19.3459 27.2108 19.2254 27.7696 19.2729C29.284 19.3951 30.4218 19.9921 31.1784 21.0676C29.824 21.8882 29.154 23.0376 29.1674 24.5122C29.1796 25.6607 29.5962 26.6164 30.4151 27.3753C30.7862 27.7275 31.2006 27.9997 31.6617 28.193C31.5617 28.483 31.4562 28.7608 31.344 29.0275V29.0275ZM27.8707 15.3601C27.8707 16.2603 27.5419 17.1008 26.8863 17.8788C26.0952 18.8037 25.1384 19.3381 24.1008 19.2538C24.0875 19.1458 24.0799 19.0321 24.0799 18.9127C24.0799 18.0485 24.4561 17.1236 25.1242 16.3674C25.4577 15.9845 25.8819 15.6662 26.3963 15.4122C26.9097 15.162 27.3952 15.0237 27.8519 15C27.8652 15.1203 27.8707 15.2407 27.8707 15.3601V15.3601Z",
    fill: "#FBFBFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_752_6435",
    x: -7.33333,
    y: -7.33333,
    width: 62.6667,
    height: 62.6667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 6.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_752_6435"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_752_6435",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_752_6435",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24 24) scale(24)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C9AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_752_6435",
    x1: 24.4666,
    y1: -0.270652,
    x2: 23.0959,
    y2: 71.0163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FAFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_752_6435"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/apple-icon.573334a4992ac7c9bae55e089f015c2c.svg";
export { ForwardRef as ReactComponent };